import { useState} from 'react';
import styles from '../styles/body.module.scss'
import btnStyles from '../styles/buttons.module.scss'
import {Box, TextField} from '@mui/material';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import axios from '../api/axios';
import useAxios from "../hooks/useAxios";
import useAxiosFunction from '../hooks/useAxiosFunction';
import FormHelperText from '@mui/material/FormHelperText';
import Autocomplete from '@mui/material/Autocomplete';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

export default function Home({siteId, setSiteId, nameOfCompleting, setNameOfCompleting, dateError, setDateError,timeDate, setTimeDate, userType, setUserType}) {

  const three_months = dayjs().subtract(3, 'month');
  const navigate = useNavigate();
  const [response, error, loading, axiosFetch] = useAxiosFunction();

  const [siteError, setSiteError] = useState(false);
  const [siteText, setSiteText] = useState('');

  const [nameOfCompletingError, setNameOfCompletingError] = useState(false);
  const [nameOfCompletingText, setNameOfCompletingText] = useState('');
  const [nameTextField, setNameTextField] = useState(false);

  const [dateTimeText, setDateTimeText] = useState('');

  const [userTypeError, setUserTypeError] = useState(false);
  const [userTypeText, setUserTypeText] = useState('');

  const [site] = useAxios({
    axiosInstance:axios,
    method:'get',
    url:'/allSites'
});

const handleSiteChange = (event, newValue) => {
  setSiteId(newValue);
};

const handleNameOfCompletingChange = (newValue) => {
  setNameOfCompleting(newValue);
};

const handleTimeDateChange = (newValue) => {
  setTimeDate(newValue);
};

const userTypeChange = (e) =>{
  setUserType(e.target.value);
}

const nextPage = () => {
  if(((timeDate !==null && timeDate.toString() !== "" && timeDate.toString() !== "Invalid Date")&&!dateError)  && siteId !== null  && (userType !== null && userType != '') ){
            setDateTimeText('');
            setSiteText('');
            setUserTypeText('');
            setDateError(false);
            setSiteError(false);
            setUserTypeError(false);

            console.log(userType)
            if("Working on Site" == userType){
              //navigate to working on site page
              navigate("/wos");
            }
            else if("Member of the Public" == userType){
              //navigate to member of the public page
              navigate("/mop");
            }
  }
  else{
          setDateTimeText('');
          setSiteText('');
          setUserTypeText('');
          setDateError(false);
          setSiteError(false);
          setUserTypeError(false);

          if(timeDate === null || timeDate.toString() === "Invalid Date"|| timeDate.toString() === ""){
              setDateTimeText('Please provide a date and time');
              setDateError(true);
          }
          if(siteId === null){
              setSiteText('Please select a site');
              setSiteError(true);
          }
          if(userType == null || userType == ''){
            setUserTypeText('Please select an option');
            setUserTypeError(true);
          }

  }
}

  return (
    <div>
        <Box className={styles.questionH1Top} >
              <h1>Where are you making your observation?</h1>
          </Box>
          <Box className={styles.textField} >
              <FormControl fullWidth margin="normal" className={styles.field} error={siteError}>
                  <Autocomplete
                      disablePortal
                      disableClearable
                      value={siteId}
                      onChange={handleSiteChange}
                      options={site}
                      getOptionLabel={(site) => site.siteName}
                      renderInput={(params) => (
                          <TextField {...params} label="Sites" error={siteError} />
                      )}
                  />
                  <FormHelperText>{siteText}</FormHelperText>
              </FormControl>
          </Box>
          <Box className={styles.questionH1}>
                <h1>Name?</h1>
                </Box>
                <Box className={styles.textField}>
                <FormControl fullWidth margin="normal" className={styles.field} error={nameOfCompletingError}>
                <TextField  error={nameOfCompletingError} value={nameOfCompleting} disabled={nameTextField} fullWidth id="outlined-basic" label="Name (Optional)" variant="outlined" onChange={e => handleNameOfCompletingChange(e.target.value)}  />
                <FormHelperText>{nameOfCompletingText}</FormHelperText>
                </FormControl>
          </Box>
          <Box className={styles.questionH1Top} >
              <h1>When did this happen?</h1>
          </Box>
          <Box className={styles.textField} >
              <FormControl fullWidth
                  margin="normal"
                  className={styles.field}
                  error={dateError}
              >
                  <DateTimePicker
                      error={dateError}
                      label="Date and Time"
                      value={timeDate}
                      ampm={false}
                      minDate={three_months}
                      disableFuture={true}
                      inputFormat="dd/MM/yyyy HH:mm"
                      onChange={handleTimeDateChange}
                      onError={(reason, value) => {
                          if (reason) {
                              setDateTimeText("Please provide a date and time");
                              setDateError(true);
                          } else {
                              setDateTimeText(null);
                              setDateError(false);
                          }
                      }}
                      renderInput={(params) => <TextField {...params} />}
                  />
                  <FormHelperText>{dateTimeText}</FormHelperText>
              </FormControl>
          </Box>
          <Box className={styles.questionH1Top} >
        <h1>Are you working on site or a member of the public?</h1>
        </Box>
        <Box className={styles.radioGroup}>
        <FormControl sx={{ m: 3 }} error={userTypeError} variant="standard">
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={userType}
        onChange={userTypeChange}
      >
        <FormControlLabel sx={{'& .MuiFormControlLabel-label': {fontSize: '1.3rem'}}}value={'Working on Site'} control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize: 30}}}/>} label="Working on Site" />
        <FormControlLabel sx={{'& .MuiFormControlLabel-label': {fontSize: '1.3rem'}}}value={'Member of the Public'} control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize: 30}}}/>} label="Member of the Public" />
      </RadioGroup>
      <FormHelperText>{userTypeText}</FormHelperText>
    </FormControl>
    </Box>
    <Box className={btnStyles.buttonContainer} >
            <Button className={btnStyles.btn} size="large" variant="contained"
             onClick={()=> nextPage()} 
             >Next</Button>
            </Box>
        
    </div>
  );
}

